import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ errorFor: "validations/errorFor" }),
    error() {
      return this.errorFor(this.name)?.join("\n");
    },
  },
};
